import MDBox from "components/MDBox";

function collapseItem(theme, ownerState) {
  const { palette, transitions, breakpoints, boxShadows, functions } = theme;
  const { active, transparentSidenav, whiteSidenav, darkMode,  } = ownerState;


  const { white, transparent, grey } = palette;
  const { md } = boxShadows;
  const { pxToRem, rgba } = functions;

  return {
    background: active
      ? "transparent"
      : transparent.main,
    color:
      (transparentSidenav && !darkMode && !active) || (whiteSidenav && !active)
        ? "#292929"
        :"#318BEC",
    fontWeight:"700",
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: active ?`${pxToRem(8)} ${pxToRem(10)}`:0,
    marginTop: `${pxToRem(1.5)} ${pxToRem(16)}`,
    marginBottom: `${pxToRem(1.5)} ${pxToRem(16)}`,
    paddingLeft: "1.6rem",
    cursor: "pointer",
    userSelect: "none",
    whiteSpace: "nowrap",
    boxShadow: active && !whiteSidenav && !darkMode && !transparentSidenav ? md : "none",
    [breakpoints.up("xl")]: {
      transition: transitions.create(["box-shadow", "background-color"], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.shorter,
      }),
    },


    "&:hover, &:focus": {
      backgroundColor: () => {
        let backgroundValue;

        if (!active) {
          backgroundValue =
            transparentSidenav && !darkMode
              ? grey[300]
              : rgba(whiteSidenav ? grey[400] : white.main, 0.2);
        }

        return backgroundValue;
      },
    },
  };
}

function collapseIconBox(theme, ownerState) {
  const { palette, transitions, borders, functions } = theme;
  const { transparentSidenav, whiteSidenav, darkMode, active } = ownerState;

  const { white, dark } = palette;
  const { borderRadius } = borders;
  const { pxToRem } = functions;

  return {
    minWidth: pxToRem(32),
    minHeight: pxToRem(32),
    color:
      (transparentSidenav && !darkMode && !active) || (whiteSidenav && !active)
        ? "#292929"
        :"#318BEC",
    borderRadius: borderRadius.md,
    display: "grid",
    placeItems: "center",
    transition: transitions.create("margin", {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.standard,
    }),

    "& svg, svg g": {
      color: transparentSidenav || whiteSidenav ? dark.main : white.main,
    },
  };
}

const collapseIcon = ({ palette: { white, gradients } }, { active }) => ({
  color: active ? white.main : gradients.dark.state,
});

function collapseText(theme, ownerState) {
  const { transitions, breakpoints, functions } = theme;
  const { miniSidenav, transparentSidenav, active } = ownerState;

  const { pxToRem } = functions;

  return {
    marginLeft: pxToRem(10),


    [breakpoints.up("xl")]: {
      opacity: miniSidenav || (miniSidenav && transparentSidenav) ? 0 : 1,
      maxWidth: miniSidenav || (miniSidenav && transparentSidenav) ? 0 : "100%",
      marginLeft: miniSidenav || (miniSidenav && transparentSidenav) ? 0 : pxToRem(10),
      transition: transitions.create(["opacity", "margin"], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.standard,
      }),
    },

    "& span": {
      fontWeight: active ? 700 : 600,
      fontSize: "18px",
      lineHeight: "30px",
      fontFamily:"urbanist",



    },

  };
}

export { collapseItem, collapseIconBox, collapseIcon, collapseText };
